import React, { useState } from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { Button, EditableInfoBlock } from '@insurancemenu/imenu-components-lib';
import { ArrowBack } from '@insurancemenu/imenu-components-lib/dist/icons';
import ActionModal from 'components/common/modals/ActionModal';
import { ModalType } from 'global/utils/ModalsHelper';
import { useRootStore } from 'store/rootStore';
import { createStyles } from './styles';

interface HeaderWithBcBlockProps {
  title?: string;
  bcBlockText: string;
  loading?: boolean;
  subtitle?: string;
  backButtonText?: string;
  headerClassName?: string;
  showBackButton?: boolean;
  onRedirect?: () => void;
}

const HeaderWithBcBlock = ({
  title = '',
  subtitle,
  headerClassName,
  showBackButton = true,
  backButtonText = 'Back',
  bcBlockText,
  loading = false,
  onRedirect,
}: HeaderWithBcBlockProps): JSX.Element => {
  const { browseInfoStore } = useRootStore();

  const [showResetModal, setShowResetModal] = useState(false);
  const history = useHistory();

  const classes = createStyles({ title });
  const backButtonStyle = !subtitle && classes.backButtonInLine;

  const onBackButtonClick = (): void => {
    history.goBack();
  };

  const onEditInfo = (): void => {
    setShowResetModal(true);
  };

  const resetProgress = (): void => {
    browseInfoStore.resetBrowseInfo();
    history.push(`/browse-info`);
    setShowResetModal(false);
  };

  return (
    <>
      <header className={clsx(classes.header, headerClassName)}>
        {showBackButton && (
          <Button
            leftIconProp={<ArrowBack />}
            type="text"
            size="medium"
            onClick={onRedirect || onBackButtonClick}
            className={clsx(classes.backButton, backButtonStyle)}
          >
            {backButtonText}
          </Button>
        )}
        {title && <h1 className={classes.title}>{title}</h1>}
        {subtitle && <p className={classes.caption}>{subtitle}</p>}
        {!loading && <EditableInfoBlock title={bcBlockText} onEditInfo={onEditInfo} className={classes.bcBlock} />}
      </header>
      <ActionModal
        show={showResetModal}
        onClose={(): void => {
          setShowResetModal(false);
        }}
        modalType={ModalType.NOTIFICATION}
        closeButtonText="Stay on Page"
        actionButtonText="Start over"
        onAction={resetProgress}
        title="Change Your Criteria"
        subtitle="Making a change to the browsing criteria will reset your search."
      />
    </>
  );
};

export default HeaderWithBcBlock;
